module.exports = __webpack_public_path__ + "img/ltkmens-2x.7ad9fce.jpg";